import React, { useState } from 'react';
import classNames from 'classnames';
import withUser from '../../withUser';
import Menu from '../../containers/menu';
import Loading from '../../components/Loading';
import Layout from './Layout';

const DefaultLayout = ({
  userIsSignedIn,
  children,
  contentStyle = {}
}) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Layout>
      {userIsSignedIn && <Menu setIsLoading={setIsLoading}/>}

      <div className={classNames('w-full flex-1 overflow-y-hidden overflow-x-auto min-h-full max-h-full', { 'pt-24': userIsSignedIn })}>
        <div
          // eslint-disable-next-line no-restricted-syntax
          style={{ ...contentStyle }}
          className="flex flex-col overflow-x-auto pt-2.5 px-38px pb-4"
        >
          {isLoading ? <Loading /> : children}
        </div>
      </div>
    </Layout>
  );
};

export default withUser(DefaultLayout);
